import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchAccessoryItems } from '../services/deviceRegistration/fetchAccessoryService';
import accessoriesFetchedAction from '../actions/accessoriesFetchedAction';

const useAccessoryItems = () => {
  const userCountry = localStorage.getItem('userCountry');
  const dispatch = useDispatch();
  const accessoriesFetchedFlag = useSelector(
    (state) => state.accessoriesFetched,
  );

  const fetchAndStoreAccessoryItems = async () => {
    try {
      dispatch(accessoriesFetchedAction('FETCHING'));
      const { deviceList } = await fetchAccessoryItems(userCountry);
      dispatch(accessoriesFetchedAction('FETCHED'));

      if (deviceList) {
        localStorage.setItem(
          'accessoryItems',
          JSON.stringify(deviceList),
        );
      }
      return null;
    } catch (error) {
      dispatch(accessoriesFetchedAction('NONE'));
      console.error('Failed to fetch accessory items:', error);
      return null;
    }
  };

  // Run effect to fetch accessories if needed
  useEffect(() => {
    if (
      accessoriesFetchedFlag === 'NONE' ||
      (!localStorage.getItem('accessoryItems') &&
        accessoriesFetchedFlag !== 'FETCHING')
    ) {
      fetchAndStoreAccessoryItems();
    }
  }, [accessoriesFetchedFlag]);
};

export default useAccessoryItems;
